/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonBadge from "components/ArgonBadge";
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

function Author({ image, name, email }) {
 
  return (
    <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
      <ArgonBox mr={2}>
        <ArgonAvatar src={image} alt={name} size="sm" variant="rounded"/>
      </ArgonBox>
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography textTransform="none" variant="button" fontWeight="medium">
          {name}
        </ArgonTypography>
        <ArgonTypography variant="caption" color="secondary">
          {email}
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>
  );
}

function Function({ job, org }) {
  return (
    <ArgonBox display="flex" flexDirection="column">
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {job}
      </ArgonTypography>
      <ArgonTypography variant="caption" color="secondary">
        {org}
      </ArgonTypography>
    </ArgonBox>
  );
}

const authorsTableData = {
  columns: [

    // { name: "author", align: "left" },
    // { name: "function", align: "left" },
    // { name: "status", align: "center" },
    // { name: "employed", align: "center" },
    // { name: "action", align: "center" },

    {name:"sno",align:"center"},
    {name:"Month",align:"left"},
    {name:"Total Sales", align:"left"},
    {name:"Net Sales",align:"center"},
    {name:"Salary",align:"center"},

  ],


  rows: [
  {
    sno: <ArgonTypography variant="caption" fontWeight="medium" color="text">1</ArgonTypography>,
    "Month": <ArgonTypography variant="caption" fontWeight="medium" color="text">December 2024</ArgonTypography>,
    "Total Sales": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹2,50,000</ArgonTypography>,
    "Net Sales": <ArgonTypography variant="caption" color="info" fontWeight="medium">₹2,00,000</ArgonTypography>,
    "Salary": <ArgonTypography variant="caption" color="text" fontWeight="medium">₹1,50,000</ArgonTypography>,
  },
  {
    sno: <ArgonTypography variant="caption" fontWeight="medium" color="text">2</ArgonTypography>,
    "Month": <ArgonTypography variant="caption" fontWeight="medium" color="text">November 2024</ArgonTypography>,
    "Total Sales": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹2,20,000</ArgonTypography>,
    "Net Sales": <ArgonTypography variant="caption" color="info" fontWeight="medium">₹1,80,000</ArgonTypography>,
    "Salary": <ArgonTypography variant="caption" color="text" fontWeight="medium">₹1,35,000</ArgonTypography>,
  },
  {
    sno: <ArgonTypography variant="caption" fontWeight="medium" color="text">3</ArgonTypography>,
    "Month": <ArgonTypography variant="caption" fontWeight="medium" color="text">October 2024</ArgonTypography>,
    "Total Sales": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹2,80,000</ArgonTypography>,
    "Net Sales": <ArgonTypography variant="caption" color="info" fontWeight="medium">₹2,25,000</ArgonTypography>,
    "Salary": <ArgonTypography variant="caption" color="text" fontWeight="medium">₹1,65,000</ArgonTypography>,
  },
  {
    sno: <ArgonTypography variant="caption" fontWeight="medium" color="text">3</ArgonTypography>,
    "Month": <ArgonTypography variant="caption" fontWeight="medium" color="text">October 2024</ArgonTypography>,
    "Total Sales": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹2,80,000</ArgonTypography>,
    "Net Sales": <ArgonTypography variant="caption" color="info" fontWeight="medium">₹2,25,000</ArgonTypography>,
    "Salary": <ArgonTypography variant="caption" color="text" fontWeight="medium">₹1,65,000</ArgonTypography>,
  },
  {
    sno: <ArgonTypography variant="caption" fontWeight="medium" color="text">3</ArgonTypography>,
    "Month": <ArgonTypography variant="caption" fontWeight="medium" color="text">October 2024</ArgonTypography>,
    "Total Sales": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹2,80,000</ArgonTypography>,
    "Net Sales": <ArgonTypography variant="caption" color="info" fontWeight="medium">₹2,25,000</ArgonTypography>,
    "Salary": <ArgonTypography variant="caption" color="text" fontWeight="medium">₹1,65,000</ArgonTypography>,
  },
  {
    sno: <ArgonTypography variant="caption" fontWeight="medium" color="text">3</ArgonTypography>,
    "Month": <ArgonTypography variant="caption" fontWeight="medium" color="text">October 2024</ArgonTypography>,
    "Total Sales": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹2,80,000</ArgonTypography>,
    "Net Sales": <ArgonTypography variant="caption" color="info" fontWeight="medium">₹2,25,000</ArgonTypography>,
    "Salary": <ArgonTypography variant="caption" color="text" fontWeight="medium">₹1,65,000</ArgonTypography>,
  },
]


//   rows: [
//   {
//     sno: <ArgonTypography variant="caption" fontWeight="medium" color="text">1</ArgonTypography>,
//     mobile: <ArgonTypography variant="caption" fontWeight="medium" color="text">9876543210</ArgonTypography>,
//     "Added on": <ArgonTypography variant="caption" fontWeight="medium" color="text">15 Dec 2024</ArgonTypography>,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//           <VisibilityIcon color="primary"/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//   {
//     sno: <ArgonTypography variant="caption" fontWeight="medium" color="text">2</ArgonTypography>,
//     mobile: <ArgonTypography variant="caption" fontWeight="medium" color="text">9123456789</ArgonTypography>,
//     "Added on": <ArgonTypography variant="caption" fontWeight="medium" color="text">12 Dec 2024</ArgonTypography>,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//           <VisibilityIcon color="primary"/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//   {
//     sno: <ArgonTypography variant="caption" fontWeight="medium" color="text">3</ArgonTypography>,
//     mobile: <ArgonTypography variant="caption" fontWeight="medium" color="text">9988776655</ArgonTypography>,
//     "Added on": <ArgonTypography variant="caption" fontWeight="medium" color="text">10 Dec 2024</ArgonTypography>,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//           <VisibilityIcon color="primary"/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//    {
//     sno: <ArgonTypography variant="caption" fontWeight="medium" color="text">3</ArgonTypography>,
//     mobile: <ArgonTypography variant="caption" fontWeight="medium" color="text">9988776655</ArgonTypography>,
//     "Added on": <ArgonTypography variant="caption" fontWeight="medium" color="text">10 Dec 2024</ArgonTypography>,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//           <VisibilityIcon color="primary"/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//    {
//     sno: <ArgonTypography variant="caption" fontWeight="medium" color="text">3</ArgonTypography>,
//     mobile: <ArgonTypography variant="caption" fontWeight="medium" color="text">9988776655</ArgonTypography>,
//     "Added on": <ArgonTypography variant="caption" fontWeight="medium" color="text">10 Dec 2024</ArgonTypography>,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//           <VisibilityIcon color="primary"/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//    {
//     sno: <ArgonTypography variant="caption" fontWeight="medium" color="text">3</ArgonTypography>,
//     mobile: <ArgonTypography variant="caption" fontWeight="medium" color="text">9988776655</ArgonTypography>,
//     "Added on": <ArgonTypography variant="caption" fontWeight="medium" color="text">10 Dec 2024</ArgonTypography>,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//           <VisibilityIcon color="primary"/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
// ]




//   rows: [
//     {
//       sno:<ArgonTypography variant="caption" fontWeight="medium" color="text">{1}</ArgonTypography>,
//       profile:<Author image={team2} name={"John Michael"} email={"john@creative-tim.com"}/>,
//       MobileNo: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"6260524679"}</ArgonTypography>,
//       JoiningDate: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"14 July 2024"}</ArgonTypography>,
//       city:<ArgonTypography variant="caption" fontWeight="medium" color="text">{"Bhopal"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//       // action:( <ArgonTypography component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
//        action: (
//        <ArgonBox display="flex" alignItems="center" gap={1}>
//            {/* View Icon */}
//            <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//             <VisibilityIcon color="primary"/>
//            </ArgonTypography>
       
//            {/* Delete Icon */}
//            <ArgonTypography  component="a" href="#" variant="body1" color="error" fontWeight="medium">
//              <DeleteIcon/>
//            </ArgonTypography>
//          </ArgonBox>
//        ),
//     },
//     {
//       sno:<ArgonTypography variant="caption" fontWeight="medium" color="text">{2}</ArgonTypography>,
//       profile:<Author image={team2} name={"John Michael"} email={"john@creative-tim.com"}/>,
//       MobileNo: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"6260524679"}</ArgonTypography>,
//       JoiningDate: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"14 July 2024"}</ArgonTypography>,
//       city:<ArgonTypography variant="caption" fontWeight="medium" color="text">{"Bhopal"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//       // action:( <ArgonTypography component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
//        action: (
//        <ArgonBox display="flex" alignItems="center" gap={1}>
//            {/* View Icon */}
//            <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//             <VisibilityIcon color="primary"/>
//            </ArgonTypography>
       
//            {/* Delete Icon */}
//            <ArgonTypography  component="a" href="#" variant="body1" color="error" fontWeight="medium">
//              <DeleteIcon/>
//            </ArgonTypography>
//          </ArgonBox>
//        ),
//     },
//     {
//       sno:<ArgonTypography variant="caption" fontWeight="medium" color="text">{3}</ArgonTypography>,
//       profile:<Author image={team2} name={"John Michael"} email={"john@creative-tim.com"}/>,
//       MobileNo: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"6260524679"}</ArgonTypography>,
//       JoiningDate: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"14 July 2024"}</ArgonTypography>,
//       city:<ArgonTypography variant="caption" fontWeight="medium" color="text">{"Bhopal"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//       // action:( <ArgonTypography component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
//        action: (
//        <ArgonBox display="flex" alignItems="center" gap={1}>
//            {/* View Icon */}
//            <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//             <VisibilityIcon color="primary"/>
//            </ArgonTypography>
       
//            {/* Delete Icon */}
//            <ArgonTypography  component="a" href="#" variant="body1" color="error" fontWeight="medium">
//              <DeleteIcon/>
//            </ArgonTypography>
//          </ArgonBox>
//        ),
//     },
//     {
//       sno:<ArgonTypography variant="caption" fontWeight="medium" color="text">{4}</ArgonTypography>,
//       profile:<Author image={team2} name={"John Michael"} email={"john@creative-tim.com"}/>,
//       MobileNo: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"6260524679"}</ArgonTypography>,
//       JoiningDate: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"14 July 2024"}</ArgonTypography>,
//       city:<ArgonTypography variant="caption" fontWeight="medium" color="text">{"Bhopal"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//       // action:( <ArgonTypography component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
//        action: (
//        <ArgonBox display="flex" alignItems="center" gap={1}>
//            {/* View Icon */}
//            <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//             <VisibilityIcon color="primary"/>
//            </ArgonTypography>
       
//            {/* Delete Icon */}
//            <ArgonTypography  component="a" href="#" variant="body1" color="error" fontWeight="medium">
//              <DeleteIcon/>
//            </ArgonTypography>
//          </ArgonBox>
//        ),
//     },
//     {
//       sno:<ArgonTypography variant="caption" fontWeight="medium" color="text">{5}</ArgonTypography>,
//       profile:<Author image={team2} name={"John Michael"} email={"john@creative-tim.com"}/>,
//       MobileNo: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"6260524679"}</ArgonTypography>,
//       JoiningDate: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"14 July 2024"}</ArgonTypography>,
//       city:<ArgonTypography variant="caption" fontWeight="medium" color="text">{"Bhopal"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//       // action:( <ArgonTypography component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
//        action: (
//        <ArgonBox display="flex" alignItems="center" gap={1}>
//            {/* View Icon */}
//            <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//             <VisibilityIcon color="primary"/>
//            </ArgonTypography>
       
//            {/* Delete Icon */}
//            <ArgonTypography  component="a" href="#" variant="body1" color="error" fontWeight="medium">
//              <DeleteIcon/>
//            </ArgonTypography>
//          </ArgonBox>
//        ),
//     },


    
// //      {
// //       sno:"2",
// //       profile:<Author image={team2} name={"John Michael"} email={"john@creative-tim.com"} />,
// //       MobileNo:"7354722929",
// //       JoiningDate:"2024-01-15 16:00:00",
// //       city:"Bhopal",
// //       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
// //       // action:( <ArgonTypography  component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
// //        action: (
// //          <ArgonBox display="flex" alignItems="center" gap={1}>
// //            {/* View Icon */}
// //            <ArgonTypography
// //              component="a"
// //              href="#"
// //              variant="caption"
// //              color="primary"
// //              fontWeight="medium"
// //            >
// //              <i className="ri-eye-fill" style={{ fontSize: "18px", cursor: "pointer" }}></i>
// //            </ArgonTypography>
       
// //            {/* Delete Icon */}
// //            <ArgonTypography
// //              component="a"
// //              href="#"
// //              variant="caption"
// //              color="error"
// //              fontWeight="medium"
// //            >
// //              <DeleteIcon/>
// //            </ArgonTypography>
// //          </ArgonBox>
// //        ),
// //       },
// //      {
// //       sno:"3",
// //       profile:<Author image={team2} name={"John Michael"} email={"john@creative-tim.com"} />,
// //       MobileNo:"7354722929",
// //       JoiningDate:"2024-01-15 16:00:00",
// //       city:"Bhopal",
// //       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
// //       action: (
// //         <ArgonBox display="flex" alignItems="center" gap={1}>
// //           {/* View Icon */}
// //           <ArgonTypography
// //             component="a"
// //             href="#"
// //             variant="caption"
// //             color="primary"
// //             fontWeight="medium"
// //           >
// //             <i className="ri-eye-fill" style={{ fontSize: "18px", cursor: "pointer" }}></i>
// //           </ArgonTypography>
      
// //           {/* Delete Icon */}
// //           <ArgonTypography
// //             component="a"
// //             href="#"
// //             variant="caption"
// //             color="error"
// //             fontWeight="medium"
// //           >
// //             <i className="ri-delete-bin-6-line" style={{ fontSize: "18px", cursor: "pointer" }}></i>
// //           </ArgonTypography>
// //         </ArgonBox>
// //       ),
// //       // action:( <ArgonTypography  component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
// //     },
// //      {
// //      sno:(<ArgonTypography variant="caption">5</ArgonTypography>),
// //    profile:<Author image={team2} name={"John Michael"} email={"john@creative-tim.com"} />,
// //       MobileNo:(<ArgonTypography variant="caption">7354722929</ArgonTypography>),
// //       JoiningDate:(<ArgonTypography variant="caption">24 july </ArgonTypography>),
// //       city:"Bhopal",
// //       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
// //       action: (
// //         <ArgonBox display="flex" alignItems="center" gap={1}>
// //           {/* View Icon */}
// //           <ArgonTypography
// //             component="a"
// //             href="#"
// //             variant="caption"
// //             color="primary"
// //             fontWeight="medium"
// //           >
// //             <i className="ri-eye-fill" style={{ fontSize: "18px", cursor: "pointer" }}></i>
// //           </ArgonTypography>
      
// //           {/* Delete Icon */}
// //           <ArgonTypography
// //             component="a"
// //             href="#"
// //             variant="caption"
// //             color="error"
// //             fontWeight="medium"
// //           >
// //             <i className="ri-delete-bin-6-line" style={{ fontSize: "18px", cursor: "pointer" }}></i>
// //           </ArgonTypography>
// //         </ArgonBox>
// //       ),
// //       // action:( <ArgonTypography  component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
// //     },
// //      {
// //       sno:(<ArgonTypography variant="caption">5</ArgonTypography>),
// //       profile:<Author image={team2} name={"John Michael"} email={"john@creative-tim.com"} />,
// //       MobileNo:"7354722929",
// //       JoiningDate:"2024-01-15 16:00:00",
// //       city:"Bhopal",
// //       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
// //       action: (
// //         <ArgonBox display="flex" alignItems="center" gap={1}>
// //           {/* View Icon */}
// //           <ArgonTypography
// //             component="a"
// //             href="#"
// //             variant="caption"
// //             color="primary"
// //             fontWeight="medium"
// //           >
// //             <i className="ri-eye-fill" style={{ fontSize: "18px", cursor: "pointer" }}></i>
// //           </ArgonTypography>
      
// //           {/* Delete Icon */}
// //           <ArgonTypography
// //             component="a"
// //             href="#"
// //             variant="caption"
// //             color="error"
// //             fontWeight="medium"
// //           >
// //             <i className="ri-delete-bin-6-line" style={{ fontSize: "18px", cursor: "pointer" }}></i>
// //           </ArgonTypography>
// //         </ArgonBox>
// //       ),
// //       // action:( <ArgonTypography  component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
// //     },


//     // {
//     //   author: <Author image={team2} name="John Michael" email="john@creative-tim.com" />,
//     //   function: <Function job="Manager" org="Organization" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       23/04/18
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },


//     // {
//     //   author: <Author image={team3} name="Alexa Liras" email="alexa@creative-tim.com" />,
//     //   function: <Function job="Programator" org="Developer" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       11/01/19
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },
//     // {
//     //   author: <Author image={team4} name="Laurent Perrier" email="laurent@creative-tim.com" />,
//     //   function: <Function job="Executive" org="Projects" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       19/09/17
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },
//     // {
//     //   author: <Author image={team3} name="Michael Levi" email="michael@creative-tim.com" />,
//     //   function: <Function job="Programator" org="Developer" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       24/12/08
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },
//     // {
//     //   author: <Author image={team2} name="Richard Gran" email="richard@creative-tim.com" />,
//     //   function: <Function job="Manager" org="Executive" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       04/10/21
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },
//     // {
//     //   author: <Author image={team4} name="Miriam Eric" email="miriam@creative-tim.com" />,
//     //   function: <Function job="Programtor" org="Developer" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       14/09/20
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },
//   ],
};

export default authorsTableData;
